import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobeAfrica } from "@fortawesome/free-solid-svg-icons";

const icons = {
  globe: <FontAwesomeIcon icon={faGlobeAfrica} size="1x" color="#2863FF" />,
};
export default icons;
